module.exports = __webpack_public_path__ + "img/Button_Spin.41f750e7.png";